import z from "zod";
import {
  type BoundingBox,
  type MaterializedPoint,
} from "~/api/generated/model";
import { type ValueOf } from "~/utils/types";

export const TABS = {
  MAP: "map",
  LIST: "list",
} as const;

export type Tab = ValueOf<typeof TABS>;

const tabSchema = z.enum(TABS).optional().catch(undefined);

const polygonSchema: z.ZodType<MaterializedPoint[]> = z.array(
  z.object({
    longitude: z.number(),
    latitude: z.number(),
  }),
);

const boundingBoxSchema: z.ZodType<BoundingBox> = z.object({
  minLongitude: z.number(),
  minLatitude: z.number(),
  maxLongitude: z.number(),
  maxLatitude: z.number(),
});

export const searchSchema = z.object({
  tab: tabSchema,
  polygon: polygonSchema.optional(),
  boundingBox: boundingBoxSchema.optional(),
  excludedLifecycleIds: z.array(z.number()).optional(),
  salesPolygon: polygonSchema.optional(),
  salesBoundingBox: boundingBoxSchema.optional(),
  excludedSaleIds: z.array(z.string()).optional(),
});

export type RentAnalysisSearch = z.infer<typeof searchSchema>;
